document.addEventListener("DOMContentLoaded", () => {
  let pinchZoomElements = document.querySelectorAll(".PinchZoomImageContainer img");

  pinchZoomElements.forEach((pinchZoomElement) => {
    hammerIt(pinchZoomElement);
  })

  function hammerIt(elm) {
    hammertime = new Hammer(elm, {});

    hammertime.get("pinch").set({
      enable: true,
    });

    var posX = 0,
      posY = 0,
      scale = 1,
      last_scale = 1,
      last_posX = 0,
      last_posY = 0,
      max_pos_x = 0,
      max_pos_y = 0,
      transform = "",
      el = elm;

    hammertime.on("pan pinch panend pinchend", function (ev) {
      //pan
      if (scale != 1) {
        posX = last_posX + ev.deltaX;
        posY = last_posY + ev.deltaY;
        max_pos_x = Math.ceil(((scale - 1) * el.clientWidth) / 2);
        max_pos_y = Math.ceil(((scale - 1) * el.clientHeight) / 2);

        if (posX > max_pos_x) {
          posX = max_pos_x;
        }
        if (posX < -max_pos_x) {
          posX = -max_pos_x;
        }
        if (posY > max_pos_y) {
          posY = max_pos_y;
        }
        if (posY < -max_pos_y) {
          posY = -max_pos_y;
        }
      }

      //pinch
      if (ev.type == "pinch") {
        scale = Math.max(0.999, Math.min(last_scale * ev.scale, 4));
      }

      if (ev.type == "pinchend") {
        last_scale = scale;
      }

      //panend
      if (ev.type == "panend") {
        last_posX = posX < max_pos_x ? posX : max_pos_x;
        last_posY = posY < max_pos_y ? posY : max_pos_y;
      }

      if (scale != 1) {
        transform = "translate3d(" + posX + "px," + posY + "px, 0) " + "scale3d(" + scale + ", " + scale + ", 1)";
      }

      if (transform) {
        el.style.webkitTransform = transform;
      }
    });
  }
});


// This script to manage data flow from Paperform form submissions to GTM.
window.addEventListener("message", (event) => {
  if (typeof event.data != "string" ||
    !event.data.startsWith("paperform:")
  )
    return;

  try {
    decodedData = JSON.parse(event.data.substring(10));
  } catch (e) {
    return;
  }

  if (
    !decodedData.hasOwnProperty("action") ||
    decodedData.action != "submission"
  )
    return;

  window.dataLayer.push({
    event: "request_form_submitted",
    formLocation: window.location.pathname,
  });
});

/** Trigger Yotpo Reviews after Search Input complete */
function reinitYotpoStars() {
  // Select the node that will be observed for mutations
  const targetNode = document.querySelector('.Search__Results');

  // Options for the observer (which mutations to observe)
  const config = { attributes: true, childList: true, subtree: true };

  // Callback function to execute when mutations are observed
  const callback = (mutationList, observer) => {
    for (const mutation of mutationList) {
      if (mutation.type === 'attributes' && mutation.attributeName === 'data-srcset') {
        if (yotpo) {
          yotpo.initWidgets();
        }
      }
    }
  };

  // Create an observer instance linked to the callback function
  const observer = new MutationObserver(callback);

  // Start observing the target node for configured mutations
  observer.observe(targetNode, config);
}

document.addEventListener('DOMContentLoaded', function() {
  reinitYotpoStars();
})
